import { Navigate, Route, Routes } from "react-router-dom";
import { RFQProvider } from "./context/RFQContext";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import PullToRefresh from "./components/PullToRefresh";
import ScrollToTop from "./components/ScrollToTop";
import Hero from "./components/Hero";
import PartnersMarquee from "./components/PartnersMarquee";
import PortfolioGrid from "./components/PortfolioGrid";
import ProductMatrix from "./components/ProductMatrix";
import AboutText from "./components/AboutText";
import StatsSection from "./components/StatsSection";
import CtaBanner from "./components/CtaBanner";
import Services from "./components/Services";
import CatalogPage from "./components/CatalogPage";
import ProductDetailPage from "./components/ProductDetailPage";
import ThemesPage from "./components/ThemesPage";
import BrandsPage from "./components/BrandsPage";
import SectorPage from "./components/SectorPage";
import ContactPage from "./components/ContactPage";
import PrivacyPolicyPage from "./components/PrivacyPolicyPage";
import ShippingAndPaymentPage from "./components/ShippingAndPaymentPage";
import RefundPolicyPage from "./components/RefundPolicyPage";
import TermsPage from "./components/TermsPage";
import BlogPage from "./components/BlogPage";
import BlogPostPage from "./components/BlogPostPage";
import LoginPage from "./components/LoginPage";
import ResetPasswordPage from "./components/ResetPasswordPage";
import VerifyEmailPage from "./components/VerifyEmailPage";
import AccountPage from "./components/AccountPage";
import AdminLoginPage from "./components/AdminLoginPage";
import AdminDashboard from "./components/AdminDashboard";
import AdminRequestsPage from "./components/AdminRequestsPage";
import NotFoundPage from "./components/NotFoundPage";
import Footer from "./components/Footer";
import RFQDrawer from "./components/RFQDrawer";
import CookieConsentBanner from "./components/CookieConsentBanner";

function HomePage() {
  return (
    <>
      <Hero />
      {/* Mobile only — on desktop the partner logo band lives inside Hero
          itself, pinned to its bottom edge (hidden there below the sm
          breakpoint). On mobile there's no room for it inside Hero, so it
          gets its own light section here instead, right after Hero and
          before the catalogue preview — `tone="dark"` swaps its logos from
          Hero's white-on-video treatment to a muted ink that reads against
          this section's white background. */}
      <PartnersMarquee tone="dark" className="bg-steel-100 py-0 sm:hidden" />
      <div className="flex flex-col bg-white">
        {/* Same order on every breakpoint, desktop included: Hero (outside
            this wrapper, always first — the partner logo band lives inside
            Hero on desktop, pinned to its bottom edge, and as its own
            mobile-only section directly above this wrapper on mobile) →
            Catalogue → About text → Stats → Portfolio → Services → CTA. DOM
            order equals visual order at every breakpoint, so no
            sm:order-* overrides are needed and desktop tab/reading order
            matches what's on screen. */}
        <ProductMatrix className="order-1" />
        <AboutText className="order-2" />
        <StatsSection className="order-3" />
        <PortfolioGrid className="order-4" />
        <Services className="order-5" />
        <CtaBanner className="order-6" />
      </div>
    </>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <RFQProvider>
          <ScrollToTop />
          <PullToRefresh />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/catalog" element={<CatalogPage />} />
              <Route path="/catalog/:productId" element={<ProductDetailPage />} />
              <Route path="/sale" element={<Navigate to="/catalog?stock=1" replace />} />
              <Route path="/themes" element={<ThemesPage />} />
              <Route path="/brands" element={<BrandsPage />} />
              <Route path="/sectors/:sectorId" element={<SectorPage />} />
              <Route path="/contacts" element={<ContactPage />} />
              <Route path="/contact" element={<Navigate to="/contacts" replace />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/privacy" element={<Navigate to="/privacy-policy" replace />} />
              <Route path="/shipping-and-payment" element={<ShippingAndPaymentPage />} />
              <Route path="/refund-policy" element={<RefundPolicyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/verify-email" element={<VerifyEmailPage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/requests" element={<AdminRequestsPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>
          <Footer />
          <RFQDrawer />
          <CookieConsentBanner />
        </RFQProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}
